import React, { Component } from 'react';
import { DragLayer } from 'react-dnd';
import * as dragTypes from '../../constants/dragTypes';
import NodeTypeDragPreview from './NodeTypeDragPreview';
import NodeTypeRefDragPreview from './NodeTypeRefDragPreview';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%'
};

function getItemStyles (props) {
  const { initialOffset, currentOffset } = props;
  if (!initialOffset || !currentOffset) {
    return {
      display: 'none'
    };
  }

  let { x, y } = currentOffset;

  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform,
    WebkitTransform: transform
  };
}

class CustomDragLayer extends Component {
  renderItem (type, item, format) {
    switch (type) {
      case dragTypes.NODE_TYPE_REF:
        return <NodeTypeRefDragPreview />;
      case dragTypes.NODE_TYPE:
        return <NodeTypeDragPreview {...item} type={this.props.nodeTypes[item.node.type]} format={format} />;
      default:
        return null;
    }
  }

  render () {
    const { item, itemType, isDragging } = this.props;

    if (!isDragging) {
      return null;
    }

    return (
      <div style={layerStyles}>
        <div style={getItemStyles(this.props)}>
          {this.renderItem(itemType, item, this.props.format)}
        </div>
      </div>
    );
  }
}

function collect (monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    initialOffset: monitor.getInitialSourceClientOffset(),
    currentOffset: monitor.getClientOffset(),
    isDragging: monitor.isDragging()
  };
}

export default DragLayer(collect)(CustomDragLayer);
